import React from "react"
import { HTMLAttributes } from "react"

type CloseProps = HTMLAttributes<SVGElement> & {
  size?: string
}

export const Close = ({ size = "16px", ...props }: CloseProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
    {...props}
  >
    <path
      d="M11.8031 5.14768C12.0656 4.88514 12.0656 4.45946 11.8031 4.19691C11.5405 3.93436 11.1149 3.93436 10.8523 4.19691L8 7.04923L5.14768 4.19691C4.88514 3.93436 4.45946 3.93436 4.19691 4.19691C3.93436 4.45946 3.93436 4.88514 4.19691 5.14768L7.04923 8L4.19691 10.8523C3.93436 11.1149 3.93436 11.5405 4.19691 11.8031C4.45946 12.0656 4.88513 12.0656 5.14768 11.8031L8 8.95077L10.8523 11.8031C11.1149 12.0656 11.5405 12.0656 11.8031 11.8031C12.0656 11.5405 12.0656 11.1149 11.8031 10.8523L8.95077 8L11.8031 5.14768Z"
      fill="currentColor"
    />
  </svg>
)
